<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t("adiantamentos") }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("despesas")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'des-adiantamentos-view',
                                            })
                                        "
                                        >{{ $t("adiantamentos") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({ name: 'des-adiantamentos-view' })
                            "
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            class="save-btn"
                            type="button"
                            @click="saveAdiantamento"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div>
                    <div class="columns">
                        <div class="column is-8">
                            <vss-select
                                :id="generateId(1)"
                                ref="colaboradorSelect"
                                label="nome"
                                placeholder="msg-selecione-um-colaborador"
                                v-model="colaborador"
                                title="colaborador"
                                :options="colaboradores"
                                :invalid="colaborador == null ? true : false"
                                searchable
                                @search="loadVendedores"
                                @input="carregarEmpresas"
                                required
                            />
                        </div>
                        <div class="column is-4">
                            <v-money
                                :id="generateId(2)"
                                ref="valorInput"
                                v-model="adiantamento.valor"
                                :value="adiantamento.valor"
                                :title="'valor'"
                                placeholder="placeholder-preencha"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="
                                    adiantamento.valor == 0 ? true : false
                                "
                                data-testid="despesas_adiantamentos_input_valor"
                                required
                            ></v-money>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-12 pt-2">
                            <vss-select
                                :id="generateId(3)"
                                label="nome"
                                placeholder="msg-selecione-um-colaborador-empresa"
                                v-model="empresaSelected"
                                title="empresa"
                                :options="empresaSelect"
                                :disabled="!colaborador"
                                ref="empresaSelectedInput"
                                :invalid="empresaSelected == null"
                            />
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column is-12">
                            <v-textarea
                                :id="generateId(4)"
                                ref="observacaoInput"
                                v-model="adiantamento.obsgeral"
                                title="observacao"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="adiantamento.obsgeral == ''"
                                placeholder="placeholder-preencha"
                                :rows="4"
                                :maxRows="4"
                                :maxlength="500"
                                :disableTransform="false"
                                data-testid="despesas_adiantamentos_input_observacao"
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdiantamentoService from "@/services/despesas/AdiantamentoService";
import ColaboradorService from "@/services/ColaboradorService";
import AdiantamentoValidation from "@/services/validations/despesas/AdiantamentoValidation";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import Message from "@/models/Message";

export default {
    data() {
        return {
            service: new AdiantamentoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(
                this.$http,
                this.$router
            ),
            empresaService: new EmpresaService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: null,
            adiantamento: {
                idusuario: null,
                valor: 0,
                obsgeral: "",
            },
            colaboradores: [],
            colaborador: null,
            permissao: {},
            empresaSelect: null,
            empresaSelected: null,
        };
    },
    watch: {
        colaborador: {
            deep: true,
            handler: function () {
                this.empresaSelected = null;
            },
        },
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "despesas",
            "cadastros",
            "des-adiantamentos"
        );
        if (!this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "adiantamentos" },
            });
        } else {
            this.validation = new AdiantamentoValidation(this.msgs);
            this.loadVendedores("");
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        loadVendedores(q) {
            this.colaboradorService
                .findListAssociated(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro com status ${r.status} ao realizar pesquisa por vendedores. Termo: [${q}].`
                        );
                        this.colaboradores = [];
                    } else {
                        this.colaboradores = r.content.map((v) => {
                            return {
                                id: v.id,
                                nome: v.nome.toLocaleUpperCase(),
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa por vendedores. Termo: [${q}].`,
                        e
                    );
                    this.colaboradores = [];
                });
        },
        updateEmpresa(e) {
            this.selectedEmpresa = e;
        },
        saveAdiantamento() {
            this.isLoading = true;
            if (
                this.validation.validate(
                    this.adiantamento,
                    this.colaborador,
                    this.empresaSelected,
                    this.$refs
                )
            ) {
                let adiantamentoTemp = this.mapTosave(this.adiantamento);
                adiantamentoTemp.idusuario = this.colaborador.id;
                adiantamentoTemp.empresa = this.empresaSelected;
                this.isSaving = true;
                this.service
                    .save(adiantamentoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = "msg-adiantamento-success-cadastrar";
                            this.msgs.push(new Message("success", msg, true));
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        this.msgs.push(
                            new Message("error", "msg-erro-load", true)
                        );
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.redirectToList();
                    });
            } else {
                this.isLoading = false;
            }
        },
        carregarEmpresas() {
            this.empresasLoading = true;
            if (this.colaborador) {
                this.empresaService
                    .findEmpresaAssByIdUsuario(this.colaborador.id)
                    .then((r) => {
                        if (r.status != 200) {
                            console.error(
                                `[TURNO] Erro status ${r.status} ao carregar empresas.`
                            );
                            console.error(`[TURNO] Mensagem: ${r.message}`);
                        } else {
                            this.empresaSelect = r.content;
                        }
                    })
                    .catch((e) => {
                        console.error("[TURNO] Erro ao carregar empresas.", e);
                    })
                    .finally((_) => {
                        this.empresasLoading = false;
                    });
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.isSaving = false;
                this.$router.push({
                    name: "des-adiantamentos",
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../../../../mixins.scss";

.column {
    @include default-size-column($height: 72px);
}

#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
    }
}
</style>
